<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex';
import * as authenticationTypes from '@/modules/authentication/store/types';

export default {
  name: 'SignOut',
  methods: {
    ...mapActions('authentication', [
      authenticationTypes.SIGN_OUT,
    ]),
  },
  async created() {
    try {
      await this.SIGN_OUT();
    } catch (e) {
      // sign-out errors are non-fatal; proceed to login regardless
    } finally {
      this.$router.push('/login');
    }
  },
};
</script>
